const SearchFilter = {
	PUBLIC: 'public',
	TEAM: 'team',
	USER: 'user',
} as const;

export const getSearchFilterLabel = (filter: ValueOf<typeof SearchFilter>) => {
	switch (filter) {
		case SearchFilter.TEAM:
			return 'Team';
		case SearchFilter.USER:
			return 'You';
		case SearchFilter.PUBLIC:
		default:
			return 'All of Savee';
	}
};

export default SearchFilter;
